import {    getFirestore,
            doc,
            setDoc, 
            getDoc,
            addDoc,
            getDocs,
            onSnapshot,
            collection,
            updateDoc,
            deleteDoc} from "firebase/firestore";

            import { db} from "../persistence/firestoreModel"
import { updateSuggestionBooks, vote, updateSuggestionInfo } from "../store/suggestionsSlice";
import { arrayToObject } from "../utils.js";

let suggestionsUnsubscribers = [];

export function updateSuggestionsListener(clubId, dispatch){ //listen to changes in the suggestions for the active club    
    suggestionsUnsubscribers.forEach(unsub => unsub());
    suggestionsUnsubscribers = [];
    if (!clubId) return;

    const suggestionsDoc = doc(db, "suggestions", String(clubId));
    const booksCollection = collection(suggestionsDoc, "book_suggestions");

    // Listen to metadata (isVotingActive, votingDeadline)
    const infoUnsub = onSnapshot(suggestionsDoc, (docSnap) => {
      if (!docSnap.exists()) return;
      const data = docSnap.data();
      dispatch(updateSuggestionInfo({
        clubId,
        isVotingActive: data.isVotingActive || false,
        votingDeadline: data.votingDeadline || ""
      }));
    }, (error) => console.error(error));

    // Listen to book suggestions
    const booksUnsub = onSnapshot(booksCollection, (snapshot) => {
      const books = snapshot.docs.map(d => ({
        bookId: d.id,
        title: d.data().title ?? null,
        pages: d.data().pages ?? null,
        genre: d.data().genre ?? null,
        author: d.data().author ?? null,
        description: d.data().description ?? null,
        bookImg: d.data().bookImg ?? null,
        totalScore: d.data().totalScore ?? 0,
        voters: Object.entries(d.data().voters ?? {}).map(([userId, score]) => ({ userId, score }))
      }));
      dispatch(updateSuggestionBooks({ clubId, suggestedBooks: books }));
    }, (error) => console.error(error));
    // Push unsubscribers once
    suggestionsUnsubscribers.push(infoUnsub, booksUnsub);
}


export function addSuggestedBook(clubId, suggestedBook){
  const suggestionsDoc = doc(db, "suggestions", String(clubId));
  const booksCollection = collection(suggestionsDoc, "book_suggestions");
  const bookDoc = doc(booksCollection, String(suggestedBook.bookId));

  setDoc(bookDoc, {
    title: suggestedBook.title ?? null,
    author: suggestedBook.author ?? null,
    pages: suggestedBook.pages ?? 0,
    genre: suggestedBook.genre ?? null,
    description: suggestedBook.description ?? null,
    bookImg: suggestedBook.bookImg ?? null,
    totalScore: 0,
    voters: {} // object, not array
  }, { merge: true });
}


export function saveSuggestionsScore(clubId, suggestedBookId, userId, score, totalScore ){
  const suggestionsDoc = doc(db, "suggestions", String(clubId));
  const booksCollection = collection(suggestionsDoc, "book_suggestions");
  const bookDoc = doc(booksCollection, String(suggestedBookId));
  console.log("saving score to firestore", clubId, suggestedBookId, userId, score, totalScore);

  return updateDoc(bookDoc, {
    [`voters.${userId}`]: score,
    totalScore
  });
}
export function saveSuggestionsInfo(info){
    const suggestionsDoc = doc(db, "suggestions", String(info.clubId))
    setDoc(suggestionsDoc, {
        isVotingActive: info.isVotingActive || false,
        votingDeadline: info.votingDeadline || "",
    }, {merge: true})
}

// clear all suggested books in Firestore for a club
export async function clearSuggestedBooks(clubId){
  const suggestionsDoc = doc(db, "suggestions", String(clubId));
  const booksCollection = collection(suggestionsDoc, "book_suggestions");
  const snapshot = await getDocs(booksCollection);
  const deletions = snapshot.docs.map(d => deleteDoc(doc(booksCollection, d.id)));
  await Promise.all(deletions);
}
